import { Link, useLocation } from 'react-router-dom';
import React, { useRef, useState, useMemo, useCallback } from 'react';

import { Button, Icon } from '@/components/ui';
import { setStoriesMap } from '@/stores/slices/popupSlice';
import { setOneModelPosition } from '@/stores/slices/mapModelSlice';
import useLadyService from '@/services/LadyService';

import GirlCardButtons from './components/GirlCardButtons';
import GirlCardSlider from './components/GirlCardSlider';
import GirlCardIconsAndTags from './components/GirlCardIconsAndTags';
import {
	minusFavoriteCounter,
	plusFavoriteCounter,
} from '@/stores/slices/userSlice';
import './girlCard.scss';
import { useSelector } from 'react-redux';
import { getUserCurrentCity } from '@/stores/slices/userSlice';
import { Checkbox } from '../../ui';
import { AddStoriesPopup } from '@/components/popups';
import StoriesCircle from '../../stories/circle/StoriesCircle';
import StoriesComponentEdit from '@/components/stories/StoriesComponentEdit';
import { makeRequest } from '@/services/makeRequest';
import MyLoader from '@/components/ui/loader/Skeleton';

const GirlCard = ({
	props = {},
	isCheckbox = true,
	agencySelectCheckbox = [],
	setAgencySelectCheckbox = false,
	checkbox = false,
	selected = false,
	ox = false,
	clazz,
	edit,
	status,
	targetBlank = false,
	infoCard = false,
	changeParty = false,
	topModelsSlider = false,
	disabled = false,
	arch = false,
	lcpCandidate,
	isLoading = false, // added isLoading prop to trigger loading state inside the card structure
}) => {
	const {
		gender,
		orientation,
		id,
		slug,
		name,
		rating,
		address,
		city,
		age,
		height,
		weight,
		breast,
		penis_size,
		languages,
		services,
		is_online,
		is_individual,
		is_top,
		is_elite,
		is_escort,
		is_healthy,
		is_verified,
		is_pornstar,
		is_new,
		tag_video,
		tag_friends,
		tag_booking,
		tag_bdsm,
		ready_travel,
		count_photos,
		count_videos,
		photos,
		is_favorite,
		healthy_at,
		verified_at,
		has_ero,
		main_photo,
		media,
		statistic = {},
		archive,
		stories: profile_stories,
		is_transferred,
		new_prices,
		district,
		is_massage,
		page,
	} = props || {};

	const { favorites } = statistic || {};

	const {
		windowWidth,
		dispatch,
		setMediaSize,
		t,
		travelVariants,
		userTypeAgency,
		lang,
		userTypeIndi,
		navigate,
		token,
	} = useLadyService();

	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');

	const toggleMapOpen = useCallback(() => {
		if (isLoading || !slug) return;
		dispatch(setOneModelPosition(slug));
		dispatch(setStoriesMap(true));
	}, [dispatch, slug, isLoading]);

	const location = useLocation();

	const [expand, setExpand] = useState(false);

	const linkRef = useRef(null);

	const setServices = Array.from(new Set(services || []));
	const currentCity = useSelector(getUserCurrentCity);

	const newArray = useMemo(() => {
		if (services?.length) {
			if (!services[0]['category_id']) {
				return setServices;
			} else {
				return services.flatMap((category) =>
					(category.services || []).map((service) => service.slug),
				);
			}
		} else {
			return [];
		}
	}, [services, setServices]);

	const ParamTemplate = useCallback(
		(translateKey, param, decimal, langs = false) => (
			<span className={'girl-card__param'}>
				<span>{t(translateKey)}</span>
				{!langs ? (
					`${param} ${decimal ? t(decimal) : ''}`
				) : (
					<div className={'flags'}>
						{(languages || [])
							.slice(0, 3)
							.map((langItem, index) => {
								if (!langItem) return null;
								const key = Object.keys(langItem)[0];
								if (!key) return null;
								return (
									<Icon
										key={'flag' + index}
										title={langItem[key]?.name}
										type={'flag'}
										spritePath={langItem[
											key
										]?.code?.toUpperCase()}
									/>
								);
							})}
						{langs.length > 3 ? `+${langs.length - 3}` : ''}
					</div>
				)}
			</span>
		),
		[languages, t, lang],
	);

	const PriceTemplate = useCallback(
		(clazz, translateKey, price, status) => (
			<span
				className={`girl-card__price--${clazz} ${status ? '' : 'disabled'}`}
			>
				<span className={'price-title'}>{t(translateKey)}</span>
				{status
					? price > 0
						? price + (lang === 'cz' ? 'Kč' : '€')
						: t('yes')
					: t('no')}
			</span>
		),
		[lang, t],
	);

	const handleAgencyCheckbox = useCallback(() => {
		if (setAgencySelectCheckbox && slug) {
			if (!agencySelectCheckbox.includes(slug)) {
				setAgencySelectCheckbox((prev) => [...prev, slug]);
			} else {
				setAgencySelectCheckbox((prev) =>
					prev.filter((item) => item !== slug),
				);
			}
		}
	}, [slug, agencySelectCheckbox, setAgencySelectCheckbox]);

	const truncateString = useCallback((str, length) => {
		return str?.length > length ? str?.slice(0, length) + '...' : str;
	}, []);

	const IconTemplate = useCallback(
		(translateKey, icon) => {
			let clazz =
				translateKey === 'erocontent'
					? is_top
						? ''
						: 'color-green'
					: '';
			let travelTitle =
				translateKey === 'travel' && ready_travel && travelVariants
					? `: ${travelVariants[ready_travel]}`
					: '';
			return (
				<Icon
					square
					clazz={clazz}
					title={`${t(translateKey)}${travelTitle}`}
					spritePath={icon}
					size={'l'}
				/>
			);
		},
		[is_top, ready_travel, t, lang, travelVariants],
	);

	const link = `/${lang}/profile/${slug}`;

	const archiveClass =
		archive && !location.pathname.includes('arch') ? ' not_active' : '';

	const topClass = is_top ? ' girl-card--top' : '';

	const eliteClass = is_elite ? ' girl-card--elite' : '';

	const statusClass = edit ? (disabled ? ' not_active' : '') : '';

	const setBigClass = ' girl-card__big';

	const setClass = clazz ? `${clazz}` : '';

	const topSliderClass = topModelsSlider ? ' top-slider-card' : '';

	const classes = `girl-card${topClass}${eliteClass}${statusClass}${setBigClass}${setClass}${archiveClass}${topSliderClass}${
		isJsdom ? ' ssr' : ''
	}${isLoading ? ' loading' : ''}`;

	const photo = !!main_photo
		? main_photo
		: !!media?.photo?.length
			? media.photo[0]
			: null;

	const showAdditionalInfo = !isJsdom && !isLoading;

	const [stories, setStories] = useState(profile_stories);
	const [isOpenAddStory, setIsOpenAddStory] = useState(false);
	const [isOpenStory, setIsOpenStory] = useState(false);

	React.useEffect(() => {
		setStories(profile_stories);
	}, [profile_stories]);

	const [favorite, setFavorite] = useState(false);

	React.useEffect(() => {
		if (!isLoading && slug) {
			let favs = [];
			if (!isJsdom) {
				try {
					const raw = localStorage.getItem('favorites');
					favs = raw ? JSON.parse(raw) : [];
					if (!Array.isArray(favs)) {
						favs = typeof raw === 'string' ? raw : [];
					}
				} catch (e) {
					favs = [];
				}
			}
			setFavorite(token ? !!is_favorite : favs.includes(slug));
		}
	}, [isLoading, slug, is_favorite, token, isJsdom]);

	const handleOpenAddStory = () => {
		if (isLoading) return;
		setIsOpenAddStory(true);
	};

	const handleOpenStory = () => {
		if (isLoading) return;
		setIsOpenStory(true);
	};

	const HandleGrowCard = useCallback(() => {
		if (isLoading || !id) return <></>;
		const el = document.querySelector(`#grow-part-${id}`);
		const offset = el?.offsetHeight;
		const girlCardStyle = isJsdom
			? {}
			: { bottom: `-${offset ? offset - 20 : 182}px` };
		return (
			<div
				className={`girl-card__group ${isJsdom ? '' : 'show-hover'}`}
				id={`grow-part-${id}`}
				style={girlCardStyle}
			>
				<div className="girl-card__modes">
					{showAdditionalInfo && (
						<>
							{!!tag_video ? (
								IconTemplate('video', 'video-play')
							) : (
								<></>
							)}
							{!!tag_friends ? (
								IconTemplate('girlfriend', 'girlfriend')
							) : (
								<></>
							)}
							{!!has_ero ? (
								IconTemplate('erocontent', 'pants')
							) : (
								<></>
							)}
							{!!tag_booking ? (
								IconTemplate('onlineorder', 'pay-content')
							) : (
								<></>
							)}
							{!!ready_travel && ready_travel !== 'no' ? (
								IconTemplate('travel', 'travel')
							) : (
								<></>
							)}
							{!!is_escort ? (
								IconTemplate('escort', 'escort')
							) : (
								<></>
							)}
							{!!newArray.length ? (
								newArray.map((item) => {
									return (
										<span key={item}>{t(`${item}-s`)}</span>
									);
								})
							) : (
								<></>
							)}
						</>
					)}
				</div>

				{showAdditionalInfo &&
				(!!height || !!weight || !!breast || !!penis_size) ? (
					<div className="girl-card__params">
						{!!height && ParamTemplate('height', height, 'cm')}
						{!!weight && ParamTemplate('weight', weight, 'kg')}
						{!!penis_size && ParamTemplate('penissize', penis_size)}
						{!!breast && ParamTemplate('breastsize', breast)}

						{!isJsdom && (!!rating || !!languages?.length) ? (
							infoCard ? (
								<></>
							) : (
								ParamTemplate('ispeak', false, false, languages)
							)
						) : (
							<></>
						)}
					</div>
				) : (
					<></>
				)}
			</div>
		);
	}, [
		lang,
		isLoading,
		id,
		isJsdom,
		showAdditionalInfo,
		tag_video,
		tag_friends,
		has_ero,
		tag_booking,
		ready_travel,
		is_escort,
		newArray,
		t,
		height,
		weight,
		penis_size,
		breast,
		rating,
		languages,
		infoCard,
		ParamTemplate,
		IconTemplate,
	]);

	const expandCard = useCallback(
		(e) => {
			e.preventDefault();
			e.stopPropagation();
			setExpand((prev) => !prev);
		},
		[setExpand],
	);

	const cardRef = useRef(null);
	const wrapperRef = useRef(null);

	const toggleFavoriteCount = useCallback(() => {
		if (isLoading || !slug) return;
		if (favorite) {
			if (token) {
				const fetchData = async () => {
					try {
						const route = `user/favorites/remove/${slug}`;
						const method = 'DELETE';
						await makeRequest({ route, method });
					} catch (error) {}
				};
				fetchData();
			} else {
				let favorites = [];
				try {
					favorites =
						JSON.parse(localStorage.getItem('favorites')) || [];
				} catch (e) {}
				favorites = favorites.filter((item) => item !== slug);
				localStorage.setItem('favorites', JSON.stringify(favorites));
			}
		} else {
			if (token) {
				const fetchData = async () => {
					try {
						const route = `user/favorites/add/${slug}`;
						const method = 'POST';
						await makeRequest({ route, method });
					} catch (error) {}
				};
				fetchData();
			} else {
				let favorites = [];
				try {
					favorites =
						JSON.parse(localStorage.getItem('favorites')) || [];
				} catch (e) {}
				if (!favorites.includes(slug)) {
					favorites.push(slug);
				}
				localStorage.setItem('favorites', JSON.stringify(favorites));
			}
		}

		dispatch(favorite ? minusFavoriteCounter() : plusFavoriteCounter());
		setFavorite(!favorite);
	}, [favorite, slug, token, dispatch, isLoading]);

	const handleGoToProfile = useCallback(() => {
		if (isLoading || !slug) return;
		navigate(`/${lang}/profile/${slug}`);
	}, [lang, slug, navigate, isLoading]);

	if (topModelsSlider) {
		return (
			<>
				<div
					ref={cardRef}
					className={classes}
				>
					<div
						ref={wrapperRef}
						className={`girl-card__wrapper ${
							expand ? 'expand' : ''
						} ${edit ? 'edit' : ''} ${isJsdom ? 'ssr' : ''}`}
					>
						{isLoading ? (
							<MyLoader />
						) : (
							<>
								<Button
									clazz={`girl-card__favorite`}
									onClick={toggleFavoriteCount}
								>
									<Icon
										size={'m'}
										spritePath={
											favorite
												? 'favorite-fill'
												: 'favorite'
										}
									/>
								</Button>

								<div
									onClick={handleGoToProfile}
									className="swiper-slide girl-card__slide"
								>
									{!!photo ? (
										<img
											loading="eager"
											fetchpriority="high"
											src={setMediaSize(photo, 's')}
											alt={
												is_massage
													? t('titlemaphoto', {
															GirlName: name,
															City:
																city ??
																currentCity?.name,
														})
													: t('altphoto', {
															GirlName: name,
															City: currentCity?.name,
														})
											}
										/>
									) : (
										<></>
									)}
								</div>

								<div className="girl-card__info-wrapper">
									<div className={`girl-card__info`}>
										<div className="d-flex girl-card__descr girl-card__name mb-0 mt-0">
											<Link
												target={
													targetBlank ? '_blank' : ''
												}
												to={
													!edit
														? link
														: `/${lang}/profile/${slug}`
												}
												onClick={() => {
													localStorage.setItem(
														'page',
														page,
													);
												}}
												ref={linkRef}
												title={
													is_online
														? `${name} ${t('online')}`
														: `${name} ${t('offline')}`
												}
												className="text-dots"
											>
												{truncateString(name, 8)}
											</Link>

											<div className="girl-card__age no-underline">
												{age}
											</div>

											<div
												className={`girl-card__tags-wrapper`}
											>
												<GirlCardIconsAndTags
													props={{
														gender,
														orientation,
														is_healthy,
														is_verified,
														healthy_at,
														verified_at,
														size: 'xs',
													}}
												/>
											</div>
										</div>

										<p className="girl-card__info-address secondary mb-0 mt-0 fz-12">
											{city
												? truncateString(city, 22)
												: ''}
										</p>

										<div
											className={
												'small-card-prices girl-card__prices mt-12'
											}
										>
											<span
												className={`girl-card__price ${
													new_prices?.incall?.status
														? ''
														: 'disabled'
												}`}
											>
												<span className={'price-title'}>
													{t('incall')}
												</span>
												{new_prices?.incall?.status
													? new_prices?.incall
															?.price > 0
														? new_prices?.incall
																?.price +
															(lang === 'cz'
																? 'Kč'
																: '€')
														: t('yes')
													: t('no')}
											</span>
											<span
												className={`girl-card__price ${
													new_prices?.outcall?.status
														? ''
														: 'disabled'
												}`}
											>
												<span className={'price-title'}>
													{t('outcall')}
												</span>
												{new_prices?.outcall?.status
													? new_prices?.outcall
															?.price > 0
														? new_prices?.outcall
																?.price +
															(lang === 'cz'
																? 'Kč'
																: '€')
														: t('yes')
													: t('no')}
											</span>
										</div>
									</div>
								</div>
							</>
						)}
					</div>
				</div>
			</>
		);
	} else {
		return (
			<>
				<div
					id={slug}
					ref={cardRef}
					className={classes}
				>
					<div
						ref={wrapperRef}
						className={`girl-card__wrapper ${
							expand ? 'expand' : ''
						} ${edit ? 'edit' : ''} ${isJsdom ? 'ssr' : ''}`}
					>
						{isLoading ? (
							<MyLoader />
						) : (
							<>
								{edit ? (
									<>
										<div className="girl-card__slider _edit">
											<Button
												clazz={`girl-card__favorite`}
											>
												<span className="color-green">
													{favorites}
												</span>
												<Icon
													size={'l'}
													spritePath={'favorite-fill'}
												/>
											</Button>

											{!(
												is_transferred && userTypeIndi
											) && (
												<Button
													size={'xs'}
													title={
														t('edit') +
														' ' +
														t('onpage') +
														' ' +
														t('myads')
													}
													clazz={`button--secondary girl-card__edit`}
													onClick={() => {
														navigate(
															`/${lang}/lk/profile/${slug}/edit`,
														);
													}}
												>
													<Icon
														spritePath={'edit-2'}
														size={'xs'}
													/>
													{t('edit')}
												</Button>
											)}

											{edit &&
											isCheckbox &&
											!changeParty ? (
												<div className="stories_wrapper">
													<StoriesCircle
														onClick={
															handleOpenAddStory
														}
														clazz={
															!status
																? 'model-header__stories disabled'
																: 'model-header__stories'
														}
														img={null}
														edit
														data={stories}
													/>
													{stories?.media && (
														<StoriesCircle
															onClick={
																handleOpenStory
															}
															img={setMediaSize(
																stories?.media,
																'xs',
															)}
															clazz={
																'model-header__stories'
															}
														/>
													)}
												</div>
											) : (
												<></>
											)}

											<div
												onClick={() => {
													navigate(
														`/${lang}/profile/${slug}`,
													);
												}}
												className="swiper-slide girl-card__slide"
											>
												{!!photo ? (
													<img
														loading="lazy"
														fetchpriority="low"
														src={
															windowWidth < 599.98
																? setMediaSize(
																		photo,
																		'l',
																	)
																: setMediaSize(
																		photo,
																		'm',
																	)
														}
														alt={
															is_massage
																? t(
																		'titlemaphoto',
																		{
																			GirlName:
																				name,
																			City:
																				city ??
																				currentCity?.name,
																		},
																	)
																: t(
																		'altphoto',
																		{
																			GirlName:
																				name,
																			City: currentCity?.name,
																		},
																	)
														}
													/>
												) : (
													<></>
												)}
											</div>

											<div
												className={`girl-card__descr ${
													isJsdom ? 'ssr' : ''
												}`}
											>
												<div
													className={`girl-card__tags-wrapper`}
												>
													<GirlCardIconsAndTags
														props={{
															gender,
															orientation,
															is_individual,
															is_healthy,
															is_verified,
															is_pornstar,
															is_new,
															tag_bdsm,
															healthy_at,
															verified_at,
														}}
													/>
												</div>
											</div>
											{userTypeAgency && isCheckbox && (
												<Checkbox
													checked={agencySelectCheckbox.includes(
														slug,
													)}
													title={''}
													onClick={
														handleAgencyCheckbox
													}
												/>
											)}
										</div>
									</>
								) : (
									<GirlCardSlider
										checkbox={checkbox}
										selected={selected}
										linkRef={linkRef}
										city={city}
										props={{
											gender,
											orientation,
											id,
											slug,
											name,
											is_healthy,
											is_verified,
											count_photos,
											count_videos,
											photos,
											is_favorite,
											has_ero,
											is_individual,
											is_new,
											tag_bdsm,
											is_pornstar,
											verified_at,
											healthy_at,
											link,
											is_massage,
										}}
										lcpCandidate={lcpCandidate}
									/>
								)}
								<div className="girl-card__info-wrapper">
									{showAdditionalInfo ? (
										<div className="girl-card__age">
											{age}
											<span>{t('years')}</span>
										</div>
									) : (
										<></>
									)}

									<div
										className={`girl-card__info ${
											isJsdom ? 'girl-card__age' : ''
										}`}
									>
										<div>
											<Link
												target={
													targetBlank ? '_blank' : ''
												}
												to={
													edit
														? link
														: `/${lang}/profile/${slug}`
												}
												ref={linkRef}
												title={
													is_online
														? `${name} ${t('online')}`
														: `${name} ${t('offline')}`
												}
												className={`girl-card__name${
													is_online
														? ' _online'
														: ' _offline'
												} mb-0 mt-0 text-dots`}
											>
												{truncateString(name, 15)}
											</Link>
											{rating ? (
												<div className={'rating'}>
													<span>
														{Math.round(rating)}
													</span>
													<Icon
														clazz={'color-green'}
														spritePath={'star-fill'}
														size={'xs'}
													/>
												</div>
											) : (
												<></>
											)}
										</div>

										{!isJsdom && !!address ? (
											<Link
												to={'#'}
												title={t('onmap')}
												className="girl-card__address"
												onClick={toggleMapOpen}
											>
												<Icon
													spritePath={'map'}
													size={'xs'}
												/>
												{city}
												{district?.slug
													? ` ${district?.name}`
													: ``}
												, {address}
											</Link>
										) : !!city ? (
											<span
												title={t('onmap')}
												className="girl-card__address"
											>
												<Icon
													spritePath={'map-pin'}
													size={'xs'}
												/>
												{city}
												{district?.name
													? ` ${district?.name}`
													: ``}
											</span>
										) : (
											<></>
										)}
									</div>
								</div>

								<div
									id={'dev-pull'}
									className="girl-card__prices"
								>
									{is_massage ? (
										<>
											<span
												className={`girl-card__price--eromassage`}
											>
												<span className={'price-title'}>
													{t('i-only')}
												</span>
												{t('massage')}
											</span>
											{PriceTemplate(
												'private',
												'incall',
												new_prices?.incall?.price,
												new_prices?.incall?.status,
											)}
											{PriceTemplate(
												'escort',
												'outcall',
												new_prices?.outcall?.price,
												new_prices?.outcall?.status,
											)}
										</>
									) : (
										<>
											{PriceTemplate(
												'private',
												'incall',
												new_prices?.incall?.price,
												new_prices?.incall?.status,
											)}
											{PriceTemplate(
												'escort',
												'outcall',
												new_prices?.outcall?.price,
												new_prices?.outcall?.status,
											)}
											{PriceTemplate(
												'accompaniment',
												'accompaniment',
												new_prices?.escort?.price,
												new_prices?.escort?.status,
											)}
										</>
									)}
									{windowWidth < 1024 && !isJsdom ? (
										<Button
											clazz={
												'girl-card__expand button-icon ' +
												(expand ? 'expand' : '')
											}
											onClick={expandCard}
										>
											<Icon
												spritePath={'chevrone-down'}
											/>
										</Button>
									) : (
										<></>
									)}
								</div>

								{!isJsdom ? (
									infoCard || arch ? (
										<></>
									) : (
										<div
											style={{ padding: '0px 12px' }}
											className={'fd-column gap-12'}
										>
											<hr />
											<GirlCardButtons
												props={props}
												edit={edit}
											/>
										</div>
									)
								) : (
									<></>
								)}

								<HandleGrowCard />
							</>
						)}
					</div>

					{!isLoading && isOpenStory && (
						<StoriesComponentEdit
							open={isOpenStory}
							setOpen={setIsOpenStory}
							setStories={setStories}
							status={status}
							data={stories}
						/>
					)}

					{!isLoading && isOpenAddStory && (
						<AddStoriesPopup
							open={isOpenAddStory}
							setOpen={setIsOpenAddStory}
							slug={slug}
							setStories={setStories}
							stories={stories}
						/>
					)}
				</div>
			</>
		);
	}
};

const FinalCard = React.memo(GirlCard);

export default FinalCard;
